export default "__VITE_ASSET__pVwyn$Rt__"